import './modules/bling';
import data from './modules/data.json';
import initAutoComplete from './modules/autocomplete';
import img from '../assets/img/*.jpg';

const $ = document.querySelectorAll.bind(document);
const $1 = document.querySelector.bind(document);

const topicIcons = {
  healthcare: 'heartbeat',
  economy: 'usd-circle',
  immigration: 'user-plus',
  politics: 'podium',
  environment: 'mountains-sun',
  education: 'graduation-hat',
  guns: 'shield-exclamation',
  taxes: 'bill'
};

const bouncex = document.querySelector('.bxc.bx-base');
if (bouncex) bouncex.remove();

const playerWrapper = $1('.county-player-wrapper');
const player = $1('.county-player');

// moves headline + byline below the lead video
const header = $1('.story-body > header');
const headline = $1('.immersive h3.title');
$1('.embed-infographic .lead-video-wrapper').insertAdjacentElement(
  'afterend',
  header
);
header.insertAdjacentElement('afterbegin', headline);

function init() {
  const countyCards = $1('.county-cards');
  const cardsFragment = new DocumentFragment();
  const iframe = $1('.county-player > iframe');
  const leadVideo = $1('.lead-video-wrapper');

  let selectedTopics = new Set();

  let domain = window.location.hostname;

  if (!['www.charlotteobserver.com', 'www.newsobserver.com'].includes(domain)) {
    domain = 'www.charlotteobserver.com';
  }

  for (const county of data.allCounties) {
    let card = document.createElement('div');
    let filename = `${county.county.toLowerCase()}_final`;

    card.className = 'county-card';
    card.dataset.name = county.county.trim();
    card.dataset.topics = county.topics;
    card.innerHTML = `
            <figure class="county-card__img "><img src="${img[filename]}" alt="${county.county} county"></figure>
            <div class="county-card__info">
                <div class="info__topics"><span>${county.county}</span></div>
                <div class="info__share">
                <a href="https://${domain}/news/politics-government/election/article${county.CUE_ID}.html"><i class="uil uil-link"></i></a>
                <a target="_blank" rel="noopener noreferrer" href="https://wwww.facebook.com/sharer/sharer.php?u=https://${domain}/news/politics-government/election/article${county.CUE_ID}.html"><i class="uil uil-facebook-f"></i></a>
                <a target="_blank" rel="noopener noreferrer" href="https://twitter.com/intent/tweet?url=https://${domain}/news/politics-government/election/article${county.CUE_ID}.html"><i class="uil uil-twitter"></i></a>
                </div>
            </div>
        `;

    if (county.county === 'Alamance') card.classList.add('county-card--active');

    let topicsDiv = card.querySelector('.info__topics');
    let topics = getTopics(county.topics);

    for (const topic of topics) {
      let el = document.createElement('i');
      el.className = `uil uil-${topicIcons[topic]}`;
      topicsDiv.appendChild(el);
    }

    cardsFragment.appendChild(card);

    card.on('click', () => {
      iframe.src = `https://${domain}/news/politics-government/election/article${county.CUE_ID}.html/video-embed`;
      iframe.setAttribute('data-name', county.county);

      if (player.dataset.closed == 'true') {
        player.classList.add('county-player--sticky');
      }

      $('.county-card').forEach(el => {
        el.classList.remove('county-card--active');
        if (el.dataset.name == iframe.dataset.name) {
          el.classList.add('county-card--active');
        }
      });
    });
  }

  countyCards.appendChild(cardsFragment);

  // init after cards are generated
  initAutoComplete(data);

  $1('.input__reset-btn').on('click', () => {
    $('.county-card').forEach(el => el.classList.remove('county-card--hidden'));
    $('.topic__btn').forEach(el => el.classList.remove('topic__btn--active'));
  });

  // Plays mini doc, shows loading circle. Loop won't fade until video is preloaded
  $1('.play-btn').on('click', function() {
    this.style.display = 'none';
    this.parentElement.querySelector('.loader').style.display = 'block';
    let pl = videojs.getPlayer('lead-mini-doc');
    pl.play();

    pl.on('canplay', function() {
      let subtitles = pl.textTracks().tracks_.find(d => d.kind == 'subtitles');
      if (subtitles) subtitles.mode = 'disabled';
      $('.logo-wrapper, .loop-wrapper').forEach(el =>
        el.classList.add('--fade-out')
      );
      $1('.loop-wrapper video').pause();
      $1('.logo-wrapper .loader').style.display = 'none';
    });
  });

  $1('.player__close').on('click', () => {
    player.classList.remove('county-player--sticky');
    let clone = iframe.src;
    iframe.src = clone;
    player.dataset.closed = true;
  });

  // Filters county cards based on selected topics
  $1('.filter__county-topics').on('click', e => {
    let btn;
    if (e.target == e.currentTarget) return;
    if (!e.target.classList.contains('topic__btn')) {
      btn = e.target.parentElement;
    } else {
      btn = e.target;
    }

    $1('.input__reset-btn').style.visibility = 'visible';

    let item = btn.dataset.topic;
    btn.classList.toggle('topic__btn--active');

    if (btn.classList.contains('topic__btn--active')) {
      selectedTopics.add(item);
    } else {
      selectedTopics.delete(item);
    }

    $(`.info__topics .uil`).forEach(d => d.classList.remove('uil--active'));

    selectedTopics.forEach(d => {
      let icons = $(`.info__topics .uil-${topicIcons[d]}`);
      icons.forEach(c => c.classList.add('uil--active'));
    });

    $('.county-card').forEach(el => {
      let cardTopics = getTopics(el.dataset.topics);
      let filtered = cardTopics.filter(d => [...selectedTopics].includes(d));

      if (filtered.length !== selectedTopics.size) {
        el.classList.add('county-card--hidden');
      } else {
        el.classList.remove('county-card--hidden');
      }
    });

    let cL = $('.county-card').length;
    let hL = $('.county-card--hidden').length;
    let noCards = $1('.county-no-results');

    if (cL == hL) {
      noCards.style.display = 'block';
    } else {
      noCards.style.display = 'none';
    }
  });

  if (window.innerWidth <= 600) {
    leadVideo.style.height = `${window.innerHeight - 52}px`;
  }

  // window.on(
  //   'resize',
  //   debounce(() => {
  //     // sets height of looping video on mobile
  //     if (window.innerWidth <= 600) {

  //     } else {
  //       leadVideo.style.height = '';
  //     }
  //   }, 100)
  // );

  window.on(
    'scroll',
    debounce(() => {
      let { top, height } = playerWrapper.getBoundingClientRect();

      if (
        top < 0 &&
        Math.abs(top) > height / 2 &&
        player.dataset.closed == 'false'
      ) {
        player.classList.add('county-player--sticky');
      } else if ((top < 0 && Math.abs(top) < height / 2) || top >= 0) {
        player.classList.remove('county-player--sticky');
        player.dataset.closed = false;
      }
    }, 25)
  );
} // end of init

function getTopics(str) {
  let topics = str
    .toLowerCase()
    .replace(/\s/g, '')
    .replace(/politicalsystem/g, 'politics')
    .split(',');

  return topics;
}

document.addEventListener('DOMContentLoaded', init);

function debounce(func, wait, immediate) {
  let timeout;
  return function() {
    let context = this;
    let args = arguments;
    const later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}
